
module.exports = {
   install: function (Vue,locale) {
      var moment = require('moment')
      moment.locale(locale)
      Vue.prototype.$moment = moment
   }
 }
 


// WEBPACK FOOTER //
// ./src/teras/vue-moment.js